import React from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
const Header = ({ title, subtitle, testID, visible = true, ...rest }) => {
    if (!visible) {
        return null;
    }
    return (React.createElement(Stack, { paddingHorizontal: "$4", ...rest },
        React.createElement(Text, { testID: `${testID}-title`, textAlign: "auto", fontSize: "$h1.strong", fontWeight: "$h1.strong", marginTop: "$4" }, title),
        React.createElement(Text, { testID: `${testID}-subtitle`, textAlign: "auto", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100", marginTop: "$4" }, subtitle)));
};
export { Header };
